import memoize from "@-/com.npmjs.memoize";

let nextDatabaseId = 0;

/**
 * Query-key serialization omits functions. Weak scalar identities keep distinct database pairs
 * separate without retaining their rows or creating another DataLoader owner.
 */
export const getQueryDatabaseId = memoize((_database: object) => nextDatabaseId++, {
  cache: new WeakMap(),
});
